import { useTranslation } from 'react-i18next';
import { SERIES_FREQUENCIES, type SeriesFrequency } from '@shared/constants/index.ts';
import type { Quote } from '@shared/types/index.ts';

const FREQUENCY_LABELS: Record<SeriesFrequency, string> = {
  one_time: 'quoteBuilder.frequency.one_time',
  weekly: 'quoteBuilder.frequency.weekly',
  biweekly: 'quoteBuilder.frequency.biweekly',
  monthly: 'quoteBuilder.frequency.monthly',
};

/**
 * The first question on a quote: how often the clean would happen.
 *
 * A radio group, not a buried dropdown. The answer is stored on the quote
 * as `preferredFrequency`.
 */
export function HowOften({
  quote,
  update,
  readOnly,
}: {
  quote: Quote;
  update: (mutate: (draft: Quote) => Quote) => void;
  readOnly: boolean;
}) {
  const { t } = useTranslation();

  return (
    <section className="card mb-6" aria-labelledby="how-often-heading">
      <h2 id="how-often-heading" className="text-lg font-semibold">
        {t('quoteBuilder.howOftenLegend')}
      </h2>
      <p className="mb-4 text-sm text-[color:var(--color-muted)]">{t('quoteBuilder.howOftenHint')}</p>
      <fieldset disabled={readOnly}>
        <legend className="sr-only">{t('quoteBuilder.howOftenLegend')}</legend>
        <div className="grid gap-2 sm:grid-cols-2">
          {SERIES_FREQUENCIES.map((frequency) => {
            const id = `how-often-${frequency}`;
            return (
              <label
                key={frequency}
                htmlFor={id}
                className="flex min-h-11 cursor-pointer items-center gap-3 rounded-md border border-[color:var(--color-line)] px-3 py-2"
              >
                <input
                  id={id}
                  type="radio"
                  name="how-often"
                  className="h-5 w-5"
                  checked={quote.preferredFrequency === frequency}
                  onChange={() => update((draft) => ({ ...draft, preferredFrequency: frequency }))}
                />
                <span className="font-medium">{t(FREQUENCY_LABELS[frequency])}</span>
              </label>
            );
          })}
        </div>
      </fieldset>
    </section>
  );
}
